import React, { useEffect } from 'react';
import './BackNav.css';
interface BackNavProps {
  label: string;
  to: string;
  title?: string;
  className?: string;
  hasUnsavedChanges?: boolean;
}

const BackNav: React.FC<BackNavProps> = ({ 
  label, 
  to, 
  title, 
  className = '',
  hasUnsavedChanges = false
}) => {
  // Set up beforeunload for page refresh/close
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (true) {
        e.preventDefault();
        e.returnValue = ''; // Chrome requires returnValue to be set
        return ''; // For other browsers
      }
    };

    if (hasUnsavedChanges) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  const handleBackClick = () => {
    window.location.href = to;
  };

  return (
    <div className={`back-nav${className ? '-' + className : ''}`}>
      <button
        className="back-button"
        onClick={handleBackClick}
        title={title || '前の画面に戻る'}
      >
        <img 
          src="/icons/back-arrow-icon.svg?v=1" 
          alt="Back" 
          className="back-arrow"
        />
        {label}
      </button>
    </div>
  );
};

export default BackNav;


